import { usePath } from "../libs/path/PathProvider";
import { Add } from "@mui/icons-material";
import FoodUtils from "../utils/FoodUtils";
import { IconButton } from "@mui/material";

export default function Header(props:{onAdd:Function}){
    const {path} = usePath()
    return <header>
        <div className="content flex middle between gap-24">
            <div className="logo"/>
            <h1 className="flex1 center">{FoodUtils.getTitle(path)}</h1>
            <IconButton onClick={e => props.onAdd()}><Add/></IconButton>
        </div>
    </header>
}